import { IonCard, IonCardContent } from '@ionic/react';
import { Button, Tab, Tabs, TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { NavLink, useHistory, useLocation, useParams } from 'react-router-dom';
import { CompetitionDTO } from '../../models/common/CompetitionDTO';
import { EventType } from '../../models/EventType';
import { RootState } from '../../models/RootState';
import { SelectedObj } from '../../models/ExchangeSportsState';
import ExpandIcon from '../../assets/images/icons/expandIcon.svg';
import {
  fetchCompetitions,
  getCompetitionsByEventType,
  setCompetition,
  fetchEventsByCompetition,
  setExchEvent,
} from '../../store';
import './ExchCompetitionsMenu.scss';
import {
  SPORTS_MAP,
  EXCH_SPORTS_MAP,
} from '../../constants/ExchangeEventTypes';
import { Autocomplete } from '@material-ui/lab';
import SVLS_API from '../../svls-api';
import { PROVIDER_ID } from '../../constants/Branding';

import { ReactComponent as SearchIcon } from '../../assets/images/common/searchIcon.svg';
import { sidebarImgMap } from '../../util/stringUtil';
import { Search, SearchOutlined } from '@material-ui/icons';
import { EventDTO } from '../../models/common/EventDTO';
import { toast } from 'react-toastify';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import LiveImg from '../../assets/images/sportsbook/icons/liveIcon.svg';
import { EXCH_COMPETITIONS_MENU } from '../../constants/CommonConstants';

type options = [{ name: string; value: string }];

type StoreProps = {
  allowedConfig: number;
  loggedIn: boolean;
  eventTypes: EventType[];
  competitions: CompetitionDTO[];
  selectedEventType: SelectedObj;
  selectedCompetition: SelectedObj;
  setExchEvent: (event: SelectedObj) => void;
  fetchCompetitions: (eventTypeId: string) => void;
  setCompetition: (competition: SelectedObj) => void;
  fetchEventsByCompetition: (
    eventTypeId: string,
    competitionId: string,
    events: EventDTO[],
    track: string
  ) => void;
  contentConfig: any;
};

type InputProps = {
  eventName: string;
};

const CompetitionsMenu: React.FC<StoreProps> = (props) => {
  const {
    allowedConfig,
    eventTypes,
    competitions,
    selectedEventType,
    selectedCompetition,
    loggedIn,
    setExchEvent,
    fetchCompetitions,
    setCompetition,
    fetchEventsByCompetition,
    contentConfig,
  } = props;

  const history = useHistory();
  const [selectEventType, setSelectEventType] = useState(selectedEventType);
  const [params, setParams] = useState(window.location.pathname);
  const [tabValue, setTabValue] = useState<number>(0);
  const [subTabValue, setSubTabValue] = useState<number>(0);
  const [eventName, setEventName] = useState<string>('');
  const [eventsData, setEventsData] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState<EventDTO>();
  const [selectedSportId, setSelectedSportId] = useState('');
  const pathParams = useParams();
  const competition = pathParams['competition'];
  const location = useLocation();
  const [sports, setSports] = useState<any>(() => {
    var sportsArr = [];
    SPORTS_MAP.forEach((value) => {
      sportsArr.push(value);
    });
    return sportsArr;
  });
  const [sideBar, setSideBar] = useState<any>([
    {
      name: 'In Play',
      className: 'eventTypes-menu-nav-link inplay',
      icon: (
        <div>
          <img
            height={20}
            width={20}
            className="side-menu-link-icon"
            src={LiveImg}
          />
        </div>
      ),
      redirectionUrl: '/exchange_sports/inplay',
      disable: false,
      priority: 0,
    },
    {
      name: 'All Sports',
      className: null,
      icon: null,
      redirectionUrl: null,
      disable: false,
      priority: 1,
    },
  ]);

  const updateSports = () => {
    var sportsArray = sports;
    contentConfig?.sports.forEach((element) => {
      var defaultSport = sportsArray.filter(
        (item) => item.name.toLowerCase() === element.name.toLowerCase()
      )[0];
      if (defaultSport) {
        defaultSport.disable = element.disabled;
        defaultSport.priority = element.priority;
      }
    });
    sportsArray.sort((a, b) => a.priority - b.priority);
    setSports([...sportsArray.filter((elem) => !elem.disable)]);
  };

  useEffect(() => {
    var sideBarArray = sideBar;
    contentConfig?.side_bar.forEach((element) => {
      var defaultElement = sideBarArray.filter(
        (item) => item.name.toLowerCase() === element.name.toLowerCase()
      )[0];
      if (defaultElement) {
        defaultElement.disable = element.disabled;
        defaultElement.priority = element.priority;

        // If type is 'All Sports'
        if (defaultElement.name === 'All Sports') {
          updateSports();
        }
      }
    });
    sideBarArray.sort((a, b) => a.priority - b.priority);
    setSideBar([...sideBarArray.filter((elem) => !elem.disable)]);
  }, [contentConfig]);

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabValue(newValue);
  };

  const handleSubTabChange = (
    event: React.ChangeEvent<{}>,
    newValue: number
  ) => {
    setSubTabValue(newValue);
  };

  const handleCompetitionChange = (c: CompetitionDTO) => {
    setCompetition({ id: c.id, name: c.name, slug: c.slug });
    // console.log('secondaryMarkets comp');
    fetchEventsByCompetition(
      selectedEventType.id,
      c.id,
      undefined,
      EXCH_COMPETITIONS_MENU
    );
  };

  useEffect(() => {
    if (!location.pathname.startsWith('/exchange_sports/inplay')) {
      if (!competitions) {
        fetchCompetitions(selectedEventType.id);
      } else {
        for (let i = 0; i < competitions.length; i += 1) {
          if (competitions[i].id === selectedCompetition.id && i !== tabValue) {
            setTabValue(i);
            handleCompetitionChange(competitions[i]);
            break;
          }
        }
      }
    }
  }, [competitions, selectedCompetition]);

  useEffect(() => {
    if (!competition) {
      setCompetition({ id: '', name: '', slug: '' });
    }
  }, []);

  const getCompetitionName = (name, sportId) => {
    if (sportId === '7' || sportId === '4339') {
      let fisrtName = name?.split('_')[0];
      let lastName = name?.split('_')[1];
      return lastName + '  (' + fisrtName + ') ';
    } else {
      return name;
    }
  };

  const searchEvent = async (val) => {
    // console.log(val);
    const response = await SVLS_API.get(
      '/catalog/v2/sports-feed/sports/events:search',
      {
        headers: {
          Authorization: sessionStorage.getItem('jwt_token'),
        },
        params: {
          providerId: PROVIDER_ID,
          query: val,
        },
      }
    );
    if (response.status == 200) {
      setEventsData(response?.data);
    }
  };

  useEffect(() => {
    if (eventName) searchEvent(eventName);
  }, [eventName]);

  const getCompetitionSlug = (competitionName: string) => {
    return competitionName
      .toLocaleLowerCase()
      .replace(/[^a-z0-9]/g, ' ')
      .replace(/ +/g, ' ')
      .trim()
      .split(' ')
      .join('-');
  };

  useEffect(() => {
    setSelectEventType(selectedEventType);
  }, [selectedEventType]);

  useEffect(() => {
    if (params?.includes('/inplay')) {
      setSelectEventType({ id: '', name: '', slug: '' });
    }
  }, [params]);

  const defaultSports = sports.map((et, eId) =>
    (allowedConfig & Number(EXCH_SPORTS_MAP[et.slug])) !== 0 ? (
      <>
        {' '}
        <div
          className="sports-competition-ctn"
          key={eId}
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          <NavLink
            className={
              selectEventType?.id === ''
                ? 'not-active eventTypes-menu-nav-link'
                : 'eventTypes-menu-nav-link'
            }
            key={et.slug + '-link'}
            to={`/exchange_sports/${et.slug}`}
            onClick={(e) => {
              if (selectEventType?.id != '' && selectEventType?.id === et?.id) {
                setSelectEventType({ id: '', name: '', slug: '' });
              } else {
                fetchCompetitions(et.id);
                setSelectEventType({
                  id: et?.id,
                  name: et?.name,
                  slug: et?.slug,
                });
                setCompetition({ id: '', name: '', slug: '' });
              }
            }}
          >
            <Tab
              className="eventTypes-menu-tab"
              label={et.name}
              value={eId}
              key={et.slug + '-tab'}
              icon={
                <div>
                  <img
                    height={20}
                    width={20}
                    className="side-menu-link-icon"
                    src={sidebarImgMap[et.slug]}
                  />
                </div>
              }
            />
            <img className="expand-icon" src={ExpandIcon} />
          </NavLink>

          {/* <div className="eventTypes-menu-tab-divider"></div> */}
          {et?.slug === selectEventType?.slug ? (
            competitions ? (
              competitions.length > 0 ? (
                <Tabs
                  orientation="vertical"
                  variant="scrollable"
                  value={subTabValue}
                  onChange={handleSubTabChange}
                  aria-label="Competitions Menu"
                  className="competitions-menu-tabs"
                  scrollButtons="off"
                >
                  {competitions?.map((c, idx) => (
                    <>
                      <NavLink
                        className="competitions-menu-nav-link"
                        key={c.slug + c.id + '-link'}
                        onClick={() => handleCompetitionChange(c)}
                        to={`/exchange_sports/${selectedEventType.slug}/${c.slug}`}
                      >
                        <Tab
                          className="competitions-menu-tab"
                          // label={c.name}
                          label={getCompetitionName(c.name, c.sportId)}
                          value={idx}
                          key={c.slug + c.id + '-tab'}
                        />
                      </NavLink>
                      {competitions.length != idx + 1 ? (
                        <div className="competitions-menu-nav-link-border-btm"></div>
                      ) : null}
                    </>
                  ))}
                </Tabs>
              ) : (
                <div className="competitions-menu-msg-text">No Competitons</div>
              )
            ) : null
          ) : null}
        </div>
      </>
    ) : null
  );

  const defaultOthers = () => {
    // TODO: update the method to have values
    return (
      <NavLink
        className="eventTypes-menu-nav-link inplay"
        to="/exchange_sports/inplay"
      >
        <Tab
          className="eventTypes-menu-tab"
          label="In play"
          value={11010010}
          icon={
            <div>
              <img
                height={20}
                width={20}
                className="side-menu-link-icon"
                src={LiveImg}
              />
            </div>
          }
        />
      </NavLink>
    );
  };

  const defaultSideBar = sideBar.map((value) =>
    value.name === 'All Sports' ? defaultSports : defaultOthers()
  );

  return (
    <div className="competitions-menu">
      <IonCard className="competitions-menu-card web-view">
        <IonCardContent className="competitions-menu-card-content">
          {loggedIn ? (
            <Autocomplete
              freeSolo
              id="free-solo-2-demo"
              className="search-events-autocomplete"
              disableClearable
              options={eventsData}
              getOptionLabel={(option) => option.eventName}
              inputValue={eventName}
              onInputChange={(event, newInputValue) => {
                setEventName(newInputValue);
              }}
              onChange={(event, newEvent) => {
                history.push(
                  `/exchange_sports/${getCompetitionSlug(
                    newEvent?.sportName
                  )}/${getCompetitionSlug(
                    newEvent?.competitionName
                  )}/${getCompetitionSlug(newEvent?.eventName)}/${btoa(
                    `${newEvent?.sportId}:${newEvent?.competitionId}:${newEvent?.eventId}`
                  )}`
                );
                setSelectedEvent(newEvent);
              }}
              renderInput={(params) => (
                <>
                  <TextField
                    {...params}
                    label="Search"
                    margin="normal"
                    variant="outlined"
                    className="search-games-text"
                    InputProps={{ ...params.InputProps, type: 'search' }}
                  />
                  <div
                    className="search-icon"
                    onClick={() =>
                      toast.error(
                        <div>
                          <ErrorIcon /> {'Please select an event from dropdown'}
                        </div>,
                        {
                          position: 'top-center',
                          autoClose: 5000,
                          hideProgressBar: true,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          progress: undefined,
                        }
                      )
                    }
                  >
                    <SearchIcon />
                  </div>
                </>
              )}
              renderOption={(props, option) => {
                return (
                  <span {...props} style={{ color: 'white' }}>
                    {props.eventName}
                  </span>
                );
              }}
            />
          ) : null}
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={tabValue}
            onChange={handleTabChange}
            aria-label="EventsTypes Menu"
            className="eventTypes-menu-tabs"
            scrollButtons="off"
          >
            {defaultSideBar}
          </Tabs>
        </IonCardContent>
      </IonCard>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    eventTypes: state.exchangeSports.eventTypes,
    competitions: getCompetitionsByEventType(
      state.exchangeSports.competitions,
      state.exchangeSports.selectedEventType.id
    ),
    selectedEventType: state.exchangeSports.selectedEventType,
    selectedCompetition: state.exchangeSports.selectedCompetition,
    allowedConfig: state.common.allowedConfig,
    loggedIn: state.auth.loggedIn,
    contentConfig: state.common.contentConfig,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchCompetitions: (eventTypeId: string) =>
      dispatch(fetchCompetitions(eventTypeId)),
    setExchEvent: (event: SelectedObj) => dispatch(setExchEvent(event)),
    setCompetition: (competition: SelectedObj) =>
      dispatch(setCompetition(competition)),
    fetchEventsByCompetition: (
      eventTypeId: string,
      competitionId: string,
      events: EventDTO[],
      track: string
    ) =>
      dispatch(
        fetchEventsByCompetition(eventTypeId, competitionId, events, track)
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CompetitionsMenu);
